import { c as _c } from "react/compiler-runtime";
import type { HofDashboardData } from '@/features/hof-dashboard/api/hof-dashboard-data';
import { Panel, ProgressPill, SectionHeading } from '@/features/hof-dashboard/components/dashboard-ui';
import { DocumentLinks } from '@/features/hof-dashboard/components/document-links';
import { FileRow } from '@/features/hof-dashboard/components/entry-answers';
import { translate } from '@/features/hof-dashboard/texts';
import type { SubmissionProgress } from '@/features/hof-dashboard/utils/submission-progress';
import type { Locale } from '@/types/types';
import type React from 'react';

/**
 * The documents to download, and the files the Hof handed in, by form: of a form of versions
 * those of the newest version, of one of entries those of every entry.
 */
export const DocumentsView: React.FC<{
  data: HofDashboardData;
  progress: Record<string, SubmissionProgress>;
  locale: Locale;
}> = t0 => {
  const $ = _c(35);
  const {
    data,
    progress,
    locale
  } = t0;
  let T0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== data.documents || $[1] !== data.forms || $[2] !== locale || $[3] !== progress) {
    let t6;
    if ($[10] !== progress) {
      t6 = form => {
        const entries = form.mode === "versions" ? form.entries.slice(0, 1) : form.entries;
        const files = entries.flatMap(_temp2);
        const formProgress = progress[form.id];
        return files.length === 0 || formProgress === undefined ? [] : [{
          form,
          files,
          progress: formProgress
        }];
      };
      $[10] = progress;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    const handedIn = data.forms.flatMap(t6);
    t4 = "space-y-6";
    let t7;
    if ($[12] !== locale) {
      t7 = translate("officialDocuments", locale);
      $[12] = locale;
      $[13] = t7;
    } else {
      t7 = $[13];
    }
    let t8;
    if ($[14] !== t7) {
      t8 = <SectionHeading>{t7}</SectionHeading>;
      $[14] = t7;
      $[15] = t8;
    } else {
      t8 = $[15];
    }
    let t9;
    if ($[16] !== data.documents || $[17] !== locale) {
      t9 = data.documents.length === 0 ? <p className="text-sm text-gray-500">{translate("noOfficialDocuments", locale)}</p> : <DocumentLinks documents={data.documents} locale={locale} />;
      $[16] = data.documents;
      $[17] = locale;
      $[18] = t9;
    } else {
      t9 = $[18];
    }
    if ($[19] !== t8 || $[20] !== t9) {
      t5 = <Panel className="space-y-2">{t8}{t9}</Panel>;
      $[19] = t8;
      $[20] = t9;
      $[21] = t5;
    } else {
      t5 = $[21];
    }
    T0 = Panel;
    t1 = "space-y-4";
    let t10;
    if ($[22] !== locale) {
      t10 = translate("submittedDocuments", locale);
      $[22] = locale;
      $[23] = t10;
    } else {
      t10 = $[23];
    }
    if ($[24] !== t10) {
      t2 = <SectionHeading>{t10}</SectionHeading>;
      $[24] = t10;
      $[25] = t2;
    } else {
      t2 = $[25];
    }
    t3 = handedIn.length === 0 ? <p className="text-sm text-gray-500">{translate("noSubmittedDocuments", locale)}</p> : <div className="divide-y divide-gray-100">{handedIn.map(t11 => {
        const {
          form: form_0,
          files: files_0,
          progress: formProgress_0
        } = t11;
        return <div key={form_0.id} className="space-y-2 py-4 first:pt-0 last:pb-0"><div className="flex flex-wrap items-center gap-2"><h4 className="text-sm font-bold text-gray-900">{form_0.title}</h4><ProgressPill progress={formProgress_0} locale={locale} /></div><ul className="grid gap-2 @2xl:grid-cols-2">{files_0.map(file => <FileRow key={file.id} file={file} locale={locale} />)}</ul></div>;
      })}</div>;
    $[0] = data.documents;
    $[1] = data.forms;
    $[2] = locale;
    $[3] = progress;
    $[4] = T0;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    T0 = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
  }
  let t6;
  if ($[26] !== T0 || $[27] !== t1 || $[28] !== t2 || $[29] !== t3) {
    t6 = <T0 className={t1}>{t2}{t3}</T0>;
    $[26] = T0;
    $[27] = t1;
    $[28] = t2;
    $[29] = t3;
    $[30] = t6;
  } else {
    t6 = $[30];
  }
  let t7;
  if ($[31] !== t4 || $[32] !== t5 || $[33] !== t6) {
    t7 = <div className={t4}>{t5}{t6}</div>;
    $[31] = t4;
    $[32] = t5;
    $[33] = t6;
    $[34] = t7;
  } else {
    t7 = $[34];
  }
  return t7;
};
function _temp(answer) {
  return answer.kind === "files" ? answer.files : [];
}
function _temp2(entry) {
  return entry.answers.flatMap(_temp);
}